export default __webpack_public_path__ + "static/media/urn_aaid_sc_US_e462e56d-a471-434e-a46e-3bb3d3d19841.89031969.png";